/**
 * Format a number in english to be displayed in a chart.
 */
export function formatChartNumber(value: number) {
    return new Intl.NumberFormat('en-US').format(value);
}
